module.exports = __webpack_public_path__ + "static/media/Gato.48888134.gif";